export enum TableEditingActionsTypes {
  START_ROW_EDITING = 'START_ROW_EDITING',
  SAVE_ROW_EDITING = 'SAVE_ROW_EDITING',
  CANCEL_ROW_EDITING = 'CANCEL_ROW_EDITING',
}
